import { Delete } from '@mui/icons-material'
import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import KanseiButton from 'components/button'
import KanseiDialog from 'components/dialog'
import KanseiMultiSelectBox from 'components/multiSelect'
import { companyApi } from 'hooks/api/company'
import { groupApi } from 'hooks/api/group'
import { CompanyGroup } from 'types/group'
import { Option } from 'types/option'

interface Props {
  companyGroup?: CompanyGroup
  onChange: () => void
}

interface Form {
  companyIds: string[]
}

export default function CompanyLinks(props: Props) {
  const { companyGroup, onChange } = props
  const [options, setOptions] = useState<Option[]>([])
  const [open, setOpen] = useState<boolean>(false)

  const { control, handleSubmit } = useForm<Form>()

  const fetchData = () => {
    companyApi()
      .getAll()
      .then((res) => {
        const options: Option[] = res.data
          .filter((company) => !company.companyGroupId)
          .map((company) => ({
            label: company.name,
            value: company.id,
          }))
        setOptions(options)
      })
  }

  useEffect(() => {
    fetchData()
  }, [companyGroup])

  const openDialog = () => {
    setOpen(true)
  }

  const handleCloseDialog = (): void => {
    setOpen(false)
  }

  const submit = (form: Form) => {
    if (form.companyIds.length == 0) {
      alert('追加する警備会社を選択してください。')
      return
    }

    groupApi()
      .addCompany(companyGroup!.id, form.companyIds)
      .then(() => {
        alert('警備会社を追加しました。')
        onChange()
        handleCloseDialog()
      })
      .catch((error) => {
        console.error('Error adding companies:', error)
        alert('警備会社の追加に失敗しました。')
      })
  }

  const handleRemoveCompany = (companyId: string) => {
    if (
      window.prompt(
        '本当に紐付けを削除しますか？紐付けを削除する場合は削除と入力してください',
      ) !== '削除'
    ) {
      alert('紐付け削除がキャンセルされました。')
      return
    }

    groupApi()
      .removeCompany(companyGroup!.id, companyId)
      .then(() => {
        alert('警備会社の紐付けを削除しました。')
        onChange()
      })
      .catch((error) => {
        console.error('Error removing company:', error)
        alert('警備会社の紐付け削除に失敗しました。')
      })
  }

  return (
    <Box sx={{ marginTop: '20px' }}>
      <Typography>警備会社一覧</Typography>
      <KanseiButton onClick={openDialog} disabled={!!companyGroup?.deletedAt}>
        新規追加
      </KanseiButton>
      <TableContainer component={Paper} sx={{ marginTop: '20px' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>削除</TableCell>
              <TableCell>会社名</TableCell>
              <TableCell>住所</TableCell>
              <TableCell>電話番号</TableCell>
              <TableCell>FAX</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {companyGroup?.companies &&
              companyGroup.companies.map((company) => (
                <TableRow key={company.id}>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() => handleRemoveCompany(company.id)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                  <TableCell>{company.name}</TableCell>
                  <TableCell>{company.address}</TableCell>
                  <TableCell>{company.phoneNumber}</TableCell>
                  <TableCell>{company.faxNumber}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <KanseiDialog open={open} handleClose={handleCloseDialog} maxWidth="lg">
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column', padding: '20px' }}
          onSubmit={handleSubmit(submit)}
        >
          {options.length > 0 ? (
            <Box>
              <Typography>追加する警備会社を選択してください</Typography>
              <KanseiMultiSelectBox
                control={control}
                name="companyIds"
                options={options}
              />
            </Box>
          ) : (
            <Typography>追加できる警備会社がありません</Typography>
          )}
          <KanseiButton buttonType="submit" disabled={options.length === 0}>
            追加
          </KanseiButton>
        </Box>
      </KanseiDialog>
    </Box>
  )
}
